const LOGIN = 'login';
const FORGOT_PASSWORD = 'forgot';
const FORGOT_PASSWORD_COMPLETE = 'forgot-complete';
const REQUEST_ACCOUNT = 'request';
const REQUEST_COMPLETE = 'req-complete';


export default {
    LOGIN,
    FORGOT_PASSWORD,
    FORGOT_PASSWORD_COMPLETE,
    REQUEST_ACCOUNT,
    REQUEST_COMPLETE
};